import { render } from "./Label.vue?vue&type=template&id=1ba47b0c"
import script from "./Label.vue?vue&type=script&setup=true&lang=js"
export * from "./Label.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Table/Fields/Label.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ba47b0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ba47b0c', __exports__)) {
    api.reload('1ba47b0c', __exports__)
  }
  
  module.hot.accept("./Label.vue?vue&type=template&id=1ba47b0c", () => {
    api.rerender('1ba47b0c', render)
  })

}


export default __exports__